import { render } from "./ChulhaAssign.vue?vue&type=template&id=936f0b2c&scoped=true"
import script from "./ChulhaAssign.vue?vue&type=script&lang=js"
export * from "./ChulhaAssign.vue?vue&type=script&lang=js"

import "./ChulhaAssign.vue?vue&type=style&index=0&id=936f0b2c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-936f0b2c"

export default script